export { default } from "./InfoBar";



// WEBPACK FOOTER //
// ./src/components/InfoBar/index.js